import { render, staticRenderFns } from "./ButtonEight.vue?vue&type=template&id=9711bb20&"
import script from "./ButtonEight.vue?vue&type=script&lang=ts&"
export * from "./ButtonEight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports